// Per-tab override of where the instructor results tables (the class page's
// Participants tab and the assignment page's Gradebook tab) read from:
//   'api'       — the Adonis API (Postgres)
//   'firestore' — the Firestore cubits
// Undefined = follow the `readResultsFromApi` feature flag. The override can
// force either source so CX can compare the two even once the flag is on.
export type ResultsReadSource = 'api' | 'firestore'

export function shouldReadResultsFromApi(
  isFlagOn: boolean,
  override?: ResultsReadSource
): boolean {
  if (override === 'api') return true
  if (override === 'firestore') return false
  return isFlagOn
}

// Narrow an untrusted value (sessionStorage) to a ResultsReadSource, or
// undefined when it isn't one.
export function parseResultsReadSource(
  value: unknown
): ResultsReadSource | undefined {
  return value === 'api' || value === 'firestore' ? value : undefined
}
